import React from "react";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import { Formik } from "formik";

const AddProspect = ({ closeModal, loading, onSubmit, validationSchema }) => {
  const platformArray = [
    "Webinar/Seminar",
    "Instagram",
    "Facebook",
    "Twitter",
    "Google Search",
    "Friends & Family",
    "Mima Sales Agent",
    "Others",
  ].map((item) => ({
    key: item,
    value: item,
  }));

  const genderArray = ["MALE", "FEMALE", "BUSINESS"].map((item) => ({
    key: item,
    value: item,
  }));
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={2}>
        Add Prospect
      </MimaText>
      <Formik
        initialValues={{
          fullname: "",
          email: "",
          mobile: "",
          gender: "",
          tag: "",
          platform: "",
          description: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaInput
              type="text"
              labelTitle="Name"
              placeholder="Enter Prospect Name"
              name="fullname"
              mb={2}
              value={values.fullname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.fullname}
              touched={touched.fullname}
            />

            <MimaInput
              type="email"
              labelTitle="Email Address"
              placeholder=" Prospect Email"
              name="email"
              mb={2}
              value={values.email}
              error={errors.email}
              touched={touched.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />

            <MimaInput
              type="text"
              labelTitle="Phone Number"
              placeholder="Prospect Phone Number"
              name="mobile"
              mb={2}
              value={values.mobile}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.mobile}
              touched={touched.mobile}
            />

            <MimaDropdown
              labelTitle="Gender"
              placeholder="Select"
              name="gender"
              data={genderArray}
              value={values.gender}
              onChange={(data) => {
                setFieldValue("gender", data.key);
              }}
              onBlur={handleBlur}
              error={errors.gender}
              touched={touched.gender}
              mb={2}
            />
            <MimaDropdown
              labelTitle="Platform"
              placeholder="Select"
              name="platform"
              data={platformArray}
              error={errors.platform}
              value={values.platform}
              onChange={(data) => {
                setFieldValue("platform", data.key);
              }}
              onBlur={handleBlur}
              mb={2}
            />
            <MimaInput
              type="text"
              labelTitle="Tag"
              placeholder="Enter Tag"
              name="tag"
              mb={2}
              value={values.tag}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.tag}
              touched={touched.tag}
            />
            <MimaTextArea
              labelTitle="Note"
              placeholder="Enter note"
              name="description"
              error={errors.description}
              touched={touched.description}
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              mb={2}
              variant="form"
              bodyVariant="bodyBase2"
            />

            <MimaButton
              title="Save"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default AddProspect;
